import React from 'react';
import {Menu, Stack, Typography} from '@mui/material';
import {CopySection} from 'presentation/components';
import {CopySectionMaskEnum} from 'presentation/constants';
import {translations} from 'presentation/translations-new';
import {StyledMenuItem} from './styles';
import {PhonesMenuRootProps, PhonesMenuWithTitleProps, PhonesMenuSimpleProps} from './types';

const {copiedPhone} = translations['pt-br'].privateFlow.bookingFlow.unitsFlow.unitDetails;

const PhonesMenuRoot = ({anchorEl, open, onClose, children, ...menuProps}: PhonesMenuRootProps) => (
	<Menu
		id="phones-menu"
		anchorEl={anchorEl}
		open={open}
		onClose={onClose}
		slotProps={{
			list: {
				sx: {
					maxWidth: 373,
					minWidth: 250,
					padding: 2,
				},
			},
		}}
		{...menuProps}>
		{children}
	</Menu>
);

const PhonesMenuWithTitle = ({phoneNumbers}: PhonesMenuWithTitleProps) => (
	<Stack gap={0.5}>
		{phoneNumbers?.map(item => (
			<StyledMenuItem key={item.title} disableRipple>
				<Stack gap={1} flex={1}>
					<Typography variant="caption">{item.title}</Typography>
					{item.phones?.map(phone => (
						<CopySection
							key={phone}
							value={phone}
							highlightedIcons
							callAction
							mask={CopySectionMaskEnum.WITHOUT_MASK}
							snackbarMessage={copiedPhone}
						/>
					))}
				</Stack>
			</StyledMenuItem>
		))}
	</Stack>
);

const PhonesMenuSimple = ({phoneNumbers, mask}: PhonesMenuSimpleProps) => (
	<Stack gap={1}>
		{phoneNumbers?.map(item => (
			<StyledMenuItem key={item} disableRipple>
				<CopySection
					mask={mask}
					value={item}
					highlightedIcons
					callAction
					snackbarMessage={copiedPhone}
				/>
			</StyledMenuItem>
		))}
	</Stack>
);

export const PhonesMenu = {
	Root: PhonesMenuRoot,
	WithTitle: PhonesMenuWithTitle,
	Simple: PhonesMenuSimple,
};
